import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {},
  module: {},
};

const plansSlice = createSlice({
  name: "plansData",
  initialState,
  reducers: {
    storeUserPlansData(state, action) {
      state.data = action.payload;
    },
    storeModuleData(state, action) {
      state.module = action.payload;
    },
  },
});

export const { storeUserPlansData } = plansSlice.actions;
export const { storeModuleData } = plansSlice.actions;

export default plansSlice.reducer;
